import { useState } from 'react'
import { PillTabs } from '../../components/ui'
import { AdminReports } from './AdminReports'
import { AdminModeration } from './AdminModeration'

const SUB_TABS = [
  { key: 'reports', label: 'Reports Queue' },
  { key: 'reasons', label: 'Report Reasons' },
] as const

type SubTab = typeof SUB_TABS[number]['key']

export function AdminModerationHub() {
  const [sub, setSub] = useState<SubTab>('reports')

  return (
    <div>
      <PillTabs tabs={[...SUB_TABS]} active={sub} onChange={setSub} style={{ marginBottom: '1.25rem' }} />
      {sub === 'reports' && <AdminReports />}
      {sub === 'reasons' && <AdminModeration />}
    </div>
  )
}
